import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import {
  getColumnKey,
  ImageThumbnailComponent,
  ImageThumbnailUnsupportedComponent,
  NoDataComponent,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import { AdminProductCollectionItem } from '../../models/admin-product-collection-item';
import { isNotNil } from '@web/utils';
import { AdminProductCollectionFilter } from '../../models/admin-product-collection-filter';
import { AdminProductStatusComponent } from '../admin-product-status/admin-product-status.component';
import { AdminProductLinkComponent } from '../admin-product-link/admin-product-link.component';

@Component({
  selector: 'app-admin-product-list-custom-cell-template',
  imports: [
    ImageThumbnailComponent,
    ImageThumbnailUnsupportedComponent,
    NgOptimizedImage,
    NoDataComponent,
    TableBodyNoReferenceCellComponent,
    AdminProductStatusComponent,
    AdminProductLinkComponent,
  ],
  templateUrl: './admin-product-list-custom-cell-template.component.html',
  styleUrl: './admin-product-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminProductListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<AdminProductCollectionItem, AdminProductCollectionFilter>>();
  /* prettier-ignore */
  public readonly model = input.required<AdminProductCollectionItem>();

  protected readonly getColumnKey = getColumnKey<AdminProductCollectionItem>;
  protected readonly isNotNil = isNotNil;
}
